export default "__VITE_ASSET__CCg9LgyL__$_?react__"